import { forwardRef, type Ref, type SVGProps } from "react";
const IconBlueprintFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 4H8v19a1 1 0 0 1-1 1H5.7a3 3 0 0 0 0 6 1.5 1.5 0 0 0 .3 0h22a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-2 19.71A2.3 2.3 0 0 1 23.71 26H17a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-1v2h5.71a.29.29 0 0 0 .29-.29V16h-2a1 1 0 0 1 0-2h2v-3.71a.29.29 0 0 0-.29-.29H12.29a.29.29 0 0 0-.29.29V14h4v-1a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0v-1h-4v7.71a.29.29 0 0 0 .29.29H13a1 1 0 0 1 0 2h-.71A2.3 2.3 0 0 1 10 23.71V10.29A2.3 2.3 0 0 1 12.29 8h11.42A2.3 2.3 0 0 1 26 10.29Z" />
    <path d="M4 22.42a5 5 0 0 1 1.32-.35A5 5 0 0 1 6 22V2a4 4 0 0 0-4 3.8A1.3 1.3 0 0 0 2 6v18a5.16 5.16 0 0 1 2-1.58" />
  </svg>
);
const ForwardRef = forwardRef(IconBlueprintFilledSVG);
ForwardRef.displayName = "IconBlueprintFilled";
export { ForwardRef as IconBlueprintFilled };
